import React, { useState } from 'react';
import { HashRouter } from 'react-router-dom';
import axios from 'axios';
import { io } from 'socket.io-client';
import SECRETS from './secrets';
import RoutesList from './RoutesList';

const socket = io(SECRETS.SOCKETURL, {
  reconnectionDelay: 10000, // defaults to 1000
  reconnectionDelayMax: 10000, // defaults to 5000
});

const App = () => {
  const [isLogged, setIsLogged] = useState(localStorage?.getItem('isLogged') ?? 'false');
  const [id, setId] = useState(localStorage?.getItem('id') ?? 0);
  const [token, setToken] = useState(localStorage?.getItem('token') ?? '');
  const [permissionLevel, setPermissionLevel] = useState(localStorage?.getItem('permissionLevel') ?? undefined);
  const [secondary, setSecondary] = useState(localStorage?.getItem('secondary') ?? undefined);

  const isValidNumber = (numParam) => typeof numParam === 'number' && !Number.isNaN(numParam) && numParam > 0;
  const isValidString = (strParam) => typeof strParam === 'string' && strParam.length > 0;
  const storageStateNewValue = (key, newValue) => {
    try {
      const storageItem = localStorage?.getItem(key);
      const defaultValuesObject = {
        isLogged: 'false',
        token: '',
        id: 0,
        permissionLevel: undefined,
        secondary: undefined,
      };
      if (newValue !== storageItem) {
        const defaultValue = defaultValuesObject?.[key] ?? 'unknown';
        if (newValue === defaultValue) localStorage.removeItem(key);
        else localStorage.setItem(key, newValue);
        switch (key) {
          case 'isLogged': setIsLogged(newValue); break;
          case 'token': setToken(newValue); break;
          case 'id': setId(newValue); break;
          case 'permissionLevel': setPermissionLevel(newValue); break;
          case 'secondary': setSecondary(newValue); break;
          default: break;
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const logIn = async (usuario, pass) => {
    try {
      axios.defaults.baseURL = SECRETS.SERVERURL;
      const response = await axios
        .post('/login', { usuario, pass })
        .catch((error) => { throw new Error(error); });
      const responseData = response?.data ?? {};
      storageStateNewValue('isLogged', 'true');
      storageStateNewValue('token', responseData?.token ?? '');
      storageStateNewValue('id', responseData?.id ?? 0);
      storageStateNewValue('permissionLevel', responseData?.permissionLevel ?? undefined);
      storageStateNewValue('secondary', `${responseData?.secondary ?? true}`);
      return { error: false };
    } catch (error) {
      console.error(error);
      return { error };
    }
  };

  const logOut = async () => {
    storageStateNewValue('isLogged', 'false');
    storageStateNewValue('id', 0);
    storageStateNewValue('permissionLevel', undefined);
    storageStateNewValue('secondary', undefined);
    if (isValidString(token)) {
      axios.defaults.baseURL = SECRETS.SERVERURL;
      axios.defaults.headers.common.Authorization = `bearer ${token}`;
      await axios
        .post('/logout')
        .catch((reason) => {
          console.error(`logOut method App error:: ${reason}`);
        });
    }
    storageStateNewValue('token', '');
  };

  const isValidSession = async () => {
    try {
      const intId = parseInt(id, 10);
      const intPermission = parseInt(permissionLevel, 10);
      if (isLogged === 'true' && isValidNumber(intId) && isValidNumber(intPermission) && isValidString(token)) {
        storageStateNewValue('isLogged', 'true');
        storageStateNewValue('token', token);
        axios.defaults.baseURL = SECRETS.SERVERURL;
        axios.defaults.headers.common.Authorization = `bearer ${token}`;
        const userRequest = await axios
          .get('/usuarios')
          .catch((reason) => { throw new Error(reason); });
        const dbUserData = userRequest?.data ?? {};
        storageStateNewValue('id', dbUserData?.idUsuario ?? 0);
        storageStateNewValue('permissionLevel', dbUserData?.permissionLevel ?? undefined);
        storageStateNewValue('secondary', `${dbUserData?.secundario ?? true}`);
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <HashRouter>
      <RoutesList
        socket={socket}
        isLogged={isLogged}
        token={token}
        secondary={secondary}
        logIn={logIn}
        logOut={logOut}
        isValidSession={isValidSession}
      />
    </HashRouter>
  );
};

export default App;
